
import Choices from "choices.js"
window.Choices = Choices;
